import React from 'react';
import { View } from 'react-native';

import Text from '../../../components/text/Text';
import Card from '../../../design/components/Card';
import SecondaryButton from '../../../design/components/SecondaryButton';
import { useThemedStyles } from '../../../hooks/useThemedStyles';

/**
 * Clock status with the Shift pass button (clocking happens on the kiosk).
 * Props: title, detail, tone ('success' | 'warning' | 'secondary'), onOpenShiftPass
 */
const ClockCard = ({ title, detail, tone, onOpenShiftPass }) => {
	const styles = useThemedStyles(createStyles);

	return (
		<Card style={styles.card}>
			<View style={styles.text}>
				<Text style={[styles.title, styles[tone]]}>{title}</Text>
				{Boolean(detail) && <Text style={styles.detail}>{detail}</Text>}
			</View>
			<SecondaryButton
				label="Shift pass"
				icon="grid"
				shape="rounded"
				onPress={onOpenShiftPass}
				style={styles.shiftPass}
			/>
		</Card>
	);
};

const createStyles = ({ ui: { colors, type, space, radius } }) => ({
	card: {
		flexDirection: 'row',
		alignItems: 'center',
		justifyContent: 'space-between',
		gap: space.md,
		paddingVertical: space.md,
		paddingRight: space.md,
		borderRadius: radius.hero,
	},
	shiftPass: {
		backgroundColor: colors.raised,
	},
	text: {
		flex: 1,
		minWidth: 0,
		gap: space.xxs,
	},
	title: {
		...type.rowTitleSemibold,
	},
	success: {
		color: colors.success,
	},
	warning: {
		color: colors.warning,
	},
	secondary: {
		color: colors.text,
	},
	detail: {
		...type.secondary,
		color: colors.textSecondary,
	},
});

export default ClockCard;
